import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import React, { useState } from "react";

export default function FAQ({
  global,
  pathPrefix,
  pathname,
  customClass = "",
  post,
  buttonTitle,
}) {
  const [open, setOpen] = useState("");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    post?.length >= 1 && (
      <section className={`${styles.root} ${customClass}`}>
        {post?.map((post, index) => (
          <Card
            key={index}
            className={`border-0 rounded-0 bg-black text-white pt-2 pb-5 text-center`}
            id={`${post.url_slug}`}
          >
            <Container>
              <Row>
                <Col md={12} className="pt-4">
                  <p className="post-title fs-4">
                    <strong>{post?.title}</strong>
                  </p>
                  <Accordion open={open} toggle={toggle} flush>
                    {post?.faq_content_1 ? (
                      <AccordionItem>
                        <AccordionHeader
                          targetId={`1-${index}`}
                          className={`${
                            post?.title === "FAQ's" ? "faq-s" : ""
                          }`}
                        >
                          <strong className="">{post?.faq_title_1}</strong>
                        </AccordionHeader>
                        <AccordionBody accordionId={`1-${index}`}>
                          {post?.faq_content_1 ? (
                            <div
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: post?.faq_content_1,
                              }}
                            />
                          ) : null}
                        </AccordionBody>
                      </AccordionItem>
                    ) : null}
                    {post?.faq_content_2 ? (
                      <AccordionItem>
                        <AccordionHeader
                          targetId={`2-${index}`}
                          className={`${
                            post?.title === "FAQ's" ? "faq-s" : ""
                          }`}
                        >
                          <strong>{post?.faq_title_2}</strong>
                        </AccordionHeader>
                        <AccordionBody accordionId={`2-${index}`}>
                          {post?.faq_content_1 ? (
                            <div
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: post?.faq_content_2,
                              }}
                            />
                          ) : null}
                        </AccordionBody>
                      </AccordionItem>
                    ) : null}
                    {post?.faq_content_3 ? (
                      <AccordionItem>
                        <AccordionHeader
                          targetId={`3-${index}`}
                          className={`${
                            post?.title === "FAQ's" ? "faq-s" : ""
                          }`}
                        >
                          <strong>{post?.faq_title_3}</strong>
                        </AccordionHeader>
                        <AccordionBody accordionId={`3-${index}`}>
                          {post?.faq_content_3 ? (
                            <div
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: post?.faq_content_3,
                              }}
                            />
                          ) : null}
                        </AccordionBody>
                      </AccordionItem>
                    ) : null}
                    {post?.faq_content_4 ? (
                      <AccordionItem>
                        <AccordionHeader
                          targetId={`4-${index}`}
                          className={`${
                            post?.title === "FAQ's" ? "faq-s" : ""
                          }`}
                        >
                          <strong>{post?.faq_title_2}</strong>
                        </AccordionHeader>
                        <AccordionBody accordionId={`4-${index}`}>
                          {post?.faq_content_4 ? (
                            <div
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: post?.faq_content_4,
                              }}
                            />
                          ) : null}
                        </AccordionBody>
                      </AccordionItem>
                    ) : null}
                    {post?.faq_content_5 ? (
                      <AccordionItem>
                        <AccordionHeader
                          targetId={`5-${index}`}
                          className={`${
                            post?.title === "FAQ's" ? "faq-s" : ""
                          }`}
                        >
                          <strong>{post?.faq_title_2}</strong>
                        </AccordionHeader>
                        <AccordionBody accordionId={`5-${index}`}>
                          {post?.faq_content_5 ? (
                            <div
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: post?.faq_content_5,
                              }}
                            />
                          ) : null}
                        </AccordionBody>
                      </AccordionItem>
                    ) : null}
                  </Accordion>
                  {post.button_label ? (
                    <div className="mt-4">
                      <Link href={post.button_link}>
                        <a className="primaryBtn no-arrow">
                          {post.button_label}
                        </a>
                      </Link>
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Container>
          </Card>
        ))}
      </section>
    )
  );
}
